import React, { useState, useEffect } from 'react';
import api from '../config/api-config';

function TicketsAtendido() {
  const [clientes, setClientes] = useState([]);
  const [chamados, setChamados] = useState([]);
  const [clienteSelecionado, setClienteSelecionado] = useState(null);
  const [loadingClientes, setLoadingClientes] = useState(true);
  const [loadingChamados, setLoadingChamados] = useState(false);
  const [erro, setErro] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setLoadingClientes(true);
    setErro(null);
    api.getClientesAtendido()
      .then((data) => {
        if (!cancelled) {
          setClientes(Array.isArray(data) ? data : []);
          setLoadingClientes(false);
        }
      })
      .catch((err) => {
        if (!cancelled) {
          setErro(err.message || 'Erro ao carregar clientes');
          setClientes([]);
          setLoadingClientes(false);
        }
      });
    return () => { cancelled = true; };
  }, []);

  useEffect(() => {
    if (!clienteSelecionado) {
      setChamados([]);
      return;
    }
    let cancelled = false;
    setLoadingChamados(true);
    api.getChamadosByCliente(clienteSelecionado.clienteId)
      .then((data) => {
        if (!cancelled) {
          const lista = Array.isArray(data) ? data : [];
          setChamados(lista);
          setLoadingChamados(false);
        }
      })
      .catch((err) => {
        if (!cancelled) {
          setErro(err.message || 'Erro ao carregar chamados');
          setChamados([]);
          setLoadingChamados(false);
        }
      });
    return () => { cancelled = true; };
  }, [clienteSelecionado]);

  const formatarData = (dataStr) => {
    if (!dataStr) return '—';
    try {
      const d = new Date(dataStr);
      if (Number.isNaN(d.getTime())) return dataStr;
      return d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' });
    } catch {
      return dataStr;
    }
  };

  return (
    <div className="tickets-atendido-page central-page">
      <div className="container">
        <header className="section-header">
          <h1>Atendido</h1>
          <p>Clientes que já abriram chamado no sistema. Selecione um cliente para ver os chamados.</p>
        </header>

        {erro && (
          <div className="alert alert-error" role="alert">
            {erro}
          </div>
        )}

        <section className="tickets-clientes-section">
          <h2>Clientes com chamados</h2>
          {loadingClientes ? (
            <p className="loading">Carregando clientes...</p>
          ) : clientes.length === 0 ? (
            <p className="text-muted">Nenhum cliente com chamado encontrado.</p>
          ) : (
            <div className="tickets-clientes-list">
              <table className="central-table">
                <thead>
                  <tr>
                    <th>Nome</th>
                    <th>Bairro</th>
                  </tr>
                </thead>
                <tbody>
                  {clientes.map((c) => (
                    <tr
                      key={c.clienteId ?? `${c.nome}-${c.bairro}`}
                      className={clienteSelecionado?.clienteId === c.clienteId ? 'selected' : ''}
                      onClick={() => setClienteSelecionado(c)}
                      role="button"
                      tabIndex={0}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          e.preventDefault();
                          setClienteSelecionado(c);
                        }
                      }}
                      aria-pressed={clienteSelecionado?.clienteId === c.clienteId}
                    >
                      <td>{c.nome ?? '—'}</td>
                      <td>{c.bairro ?? '—'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </section>

        {clienteSelecionado && (
          <section className="tickets-chamados-section">
            <h2>Chamados de {clienteSelecionado.nome}</h2>
            {loadingChamados ? (
              <p className="loading">Carregando chamados...</p>
            ) : (
              <div className="tickets-chamados-grid">
                <table className="central-table">
                  <thead>
                    <tr>
                      <th>Nº</th>
                      <th>Data abertura</th>
                      <th>Assunto</th>
                      <th>Status</th>
                      <th>Chamado</th>
                    </tr>
                  </thead>
                  <tbody>
                    {chamados.length === 0 ? (
                      <tr>
                        <td colSpan="5" className="text-muted">Nenhum chamado para este cliente.</td>
                      </tr>
                    ) : (
                      chamados.map((ch) => (
                        <tr key={ch.id}>
                          <td>{ch.id ?? ch.numero ?? '—'}</td>
                          <td>{formatarData(ch.dataAbertura)} {ch.horaAbertura ? ` ${ch.horaAbertura}` : ''}</td>
                          <td>{ch.assunto ?? '—'}</td>
                          <td><span className={`status-badge ${(ch.status || '').toLowerCase()}`}>{ch.status ?? '—'}</span></td>
                          <td className="chamado-texto">{ch.chamado ?? '—'}</td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            )}
          </section>
        )}
      </div>
    </div>
  );
}

export default TicketsAtendido;
